export class MerchantFinanceApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * D405: the merchants that have statements, under `settlement:view` (a finance operator picks a merchant here
     * without the directory word `merchant:view`). Scoped by the session's grants alone — it takes no argument.
     */
    listMerchants() {
        return this.client.request({ method: 'GET', path: '/v1/merchant-finance/merchants', auth: true });
    }
    /** Build a daily merchant statement (the id is server-minted; the record is insert-once/immutable). */
    createStatement(input) {
        return this.client.request({ method: 'POST', path: '/v1/merchant-finance/statements', body: input, auth: true });
    }
    /** Read one statement by its id. */
    getStatement(statementId) {
        return this.client.request({ method: 'GET', path: `/v1/merchant-finance/statements/${encodeURIComponent(statementId)}`, auth: true });
    }
    /** A merchant's statement history, newest first. */
    listStatements(merchantId) {
        return this.client.request({ method: 'GET', path: `/v1/merchant-finance/merchants/${encodeURIComponent(merchantId)}/statements`, auth: true });
    }
    /** Initiate a payout for a statement — the amount is the statement's net payable by construction (id server-minted). */
    initiatePayout(statementId, input) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-finance/statements/${encodeURIComponent(statementId)}/payout`, body: input, auth: true });
    }
    /** Mark a pending payout paid, capturing the external transaction reference (terminal). */
    markPaid(payoutId, input) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-finance/payouts/${encodeURIComponent(payoutId)}/mark-paid`, body: input, auth: true });
    }
    /** Mark a pending payout failed, capturing a stable failure code (terminal). */
    markFailed(payoutId, input) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-finance/payouts/${encodeURIComponent(payoutId)}/mark-failed`, body: input, auth: true });
    }
    /** Read one payout by its id. */
    getPayout(payoutId) {
        return this.client.request({ method: 'GET', path: `/v1/merchant-finance/payouts/${encodeURIComponent(payoutId)}`, auth: true });
    }
    /** A statement's payouts, newest first. */
    listPayouts(statementId) {
        return this.client.request({ method: 'GET', path: `/v1/merchant-finance/statements/${encodeURIComponent(statementId)}/payouts`, auth: true });
    }
    /** D480 (M-08): the real extract of what the earnings ledger owed the merchant in a market over a period of its LOCAL days. */
    earnings(merchantId, input) {
        const q = `marketId=${encodeURIComponent(input.marketId)}&from=${encodeURIComponent(input.from)}&to=${encodeURIComponent(input.to)}`;
        return this.client.request({ method: 'GET', path: `/v1/merchant-finance/merchants/${encodeURIComponent(merchantId)}/earnings?${q}`, auth: true });
    }
    /** D480 (M-08): Finance builds the day's statement FROM the bookings (insert-once per merchant × market × day; `STATEMENT_EXISTS` / `NO_EARNINGS` are 409). */
    statementFromEarnings(merchantId, input) {
        return this.client.request({ method: 'POST', path: `/v1/merchant-finance/merchants/${encodeURIComponent(merchantId)}/statements/from-earnings`, body: input, auth: true });
    }
}
//# sourceMappingURL=merchant-finance.js.map